import axios from 'axios'
const API_URL = process.env.GATSBY_GIFTING_FLOW_API_URL || ''
const baseURL = API_URL.endsWith('/') ? API_URL.slice(0, -1) : API_URL

export const redeemGift = async ({ slug, subscribe, order_attrs }) => {
  try {
    const response = await axios.post(`${baseURL}/redeem_gift/${slug}`, {
      subscribe,
      order_attrs
    })

    return response.data
  } catch (error) {
    console.error('Axios Error:', error)

    return new Error(error)
  }
}
